/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum BusinessSettingsVersionColumnEnum {
    VERSION = 'VERSION',
    STATUS = 'STATUS',
    ACTIVATION_DATE = 'ACTIVATION_DATE',
    PATH_ALERTS = 'PATH_ALERTS',
    UPDATED_BY = 'UPDATED_BY',
    NOTES = 'NOTES'
}
